module.exports = [{
      plugin: require('../../node_modules/gatsby-plugin-loadable-components-ssr/gatsby-browser.js'),
      options: {"plugins":[],"preloadTags":true},
    },{
      plugin: require('../../node_modules/gatsby-plugin-rudderstack/gatsby-browser.js'),
      options: {"plugins":[],"prodKey":"2HzGl70PzqpIXvuLIAEmERR4myM","devKey":"2DQXzhXg7d9crYJVHIu36U4LQdh","trackPage":true,"trackPageDelay":50,"delayLoad":false,"delayLoadTime":1000,"manualLoad":false,"loadType":"defer","loadOptions":{}},
    },{
      plugin: require('../../node_modules/@sentry/gatsby/gatsby-browser.js'),
      options: {"plugins":[],"environment":"production","dsn":"https://b744880ee7054daebaf2de98f1e9a69b@o264001.ingest.sentry.io/4504314678411264","tracesSampleRate":0.02,"browserTracingOptions":{"traceXHR":true}},
    },{
      plugin: require('../gatsby-browser.ts'),
      options: {"plugins":[]},
    },{
      plugin: require('../../node_modules/gatsby/dist/internal-plugins/partytown/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
